import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule, PoNotificationModule } from '@po-ui/ng-components';
import { CustomFieldsFormComponent } from '../../custom-fields/custom-fields-form/custom-fields-form.component';
import { CustomFieldsViewComponent } from '../../custom-fields/custom-fields-view/custom-fields-view.component';
import { AccountModule } from '../account/account.module';
import { EmptyCardListComponent } from '../empty-card-list/empty-card-list.component';
import { FilterComponent } from '../filter/filter.component';
import { ShowMoreButtonComponent } from '../show-more-button/show-more-button.component';
import { PipeModule } from './../../pipe/pipe.module';
import { DeviceButtonComponent } from './../device-button/device-button.component';
import { FooterComponent } from './../footer/footer.component';
import { LoadingComponent } from './../loading/loading.component';
import { SideBarComponent } from './../side-bar/side-bar.component';
import { NotificationModalComponent } from '../notification-modal/notification-modal.component';
import { DetailsTaxesComponent } from '../details-taxes/details-taxes.component';
import { PdfCustomChoiceComponent } from '../pdf-custom-choice/pdf-custom-choice.component';
import { ProductimageComponent } from '../productimage/productimage.component';

@NgModule({
  declarations: [
    SideBarComponent,
    ShowMoreButtonComponent,
    FooterComponent,
    FilterComponent,
    EmptyCardListComponent,
    LoadingComponent,
    DeviceButtonComponent,
    CustomFieldsViewComponent,
    CustomFieldsFormComponent,
    NotificationModalComponent,
    DetailsTaxesComponent,
    PdfCustomChoiceComponent,
    ProductimageComponent
  ],
  imports: [CommonModule, PoModule, FormsModule, ReactiveFormsModule, PoNotificationModule, PipeModule, AccountModule],
  exports: [
    CommonModule,
    PoModule,
    SideBarComponent,
    FormsModule,
    ReactiveFormsModule,
    ShowMoreButtonComponent,
    PoNotificationModule,
    PipeModule,
    FooterComponent,
    FilterComponent,
    EmptyCardListComponent,
    LoadingComponent,
    DeviceButtonComponent,
    AccountModule,
    CustomFieldsViewComponent,
    CustomFieldsFormComponent,
    NotificationModalComponent,
    DetailsTaxesComponent,
    PdfCustomChoiceComponent,
    ProductimageComponent
  ]
})
export class SharedModule {}
